import TalentAppStep from "../components/TalentAppStep";
import KeyClientsForm from "../components/KeyClientsForm";
import React from "react";

const MIN_CASE_STUDIES_REQUIRED = 2;
export default class WorkSamplesStep extends TalentAppStep
{
    static path = '/project-case-studies';
    static LastUpdatedMethod = 'lastUpdatedPortfolio';

    static HasRequirements = true;
    /**
     * The title shown on the form
     */
    static StepTitle = 'Project Highlights';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = TB.trans('talent.portfolio.step_subtitle');
    /**
     * The start page info tile
     */
    static StepInfo = 'Project Highlights'
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Work Highlights';
    /**
     * show completion icon on sidebar
     */
    static NeedsCompletion = (user) => {
        return user.isOnTalentMarketplace();
    };
    /**
     * Show brief details for user
     */
    static ProfileSectionSummary = (user) => {
        if(!this.hasCompleted(user)) return false;
        return `${user.key_clients?.length} Project Highlights`;
    };

    static hasCompleted(user)
    {
        if (!user.isOnTalentMarketplace()) {
            return true;
        }
        let items = TB.filter(user.key_clients || [], item => TB.isDefined(item?.headline))

        return items.length >= MIN_CASE_STUDIES_REQUIRED
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        return user.validatePortfolio()
    };
    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        if (!user.isOnTalentMarketplace()) {
            return false;
        }
        if (!user.validatePortfolio() || TB.filter(user?.key_clients || [], kc => !!kc?.id)?.length < MIN_CASE_STUDIES_REQUIRED) {
            return this;
        }

        return false;
    };
    /**
     * Are requirements optional
     *
     * @returns boolean
     */
    isRequirementOptional() {
        return !this.props.authUser.isOnTalentMarketplace?.();
    }
    /**
     * Are requirements completed?
     *
     * @returns boolean
     */
    isRequirementComplete() {
        return !this.props.authUser?.isOnTalentMarketplace() ||
            TB.filter(this.props.authUser?.key_clients || [], kc => !!kc?.id)?.length >= MIN_CASE_STUDIES_REQUIRED;
    }
    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return this.props.authUser.isOnTalentMarketplace() ? `At least ${MIN_CASE_STUDIES_REQUIRED} Project Highlights are required.` : 'Project Highlights are optional and not required.';
    }

    renderFormFooter() {
        return <div className="flex flex-col items-stretch">
            {this.renderChildForm({
                displayName: 'Project Highlight',
                header: null,
                ChildFormComponent: KeyClientsForm,
                userProp: 'key_clients'
            })}
        </div>
    }
}


const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};